export default {
    RUMAH: 'RUMAH',
    KERJA: 'KERJA',
    HP: 'HP',
    HP_PRIMARY: 'HP_PRIMARY',
    LAINNYA: 'LAINNYA'
}
